import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  props: {
    liveInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    lockName: {
      type: Boolean,
      default() {
        return false;
      }
    },
    MeInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    channel: {
      type: Object,
      default() {
        return {};
      }
    },
    shareInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    showRightAside: {
      type: Boolean,
      default: false
    },
    rtc: {
      type: Object,
      default: function () {
        return {};
      }
    },
    degreeHost: {
      type: Object,
      default: function () {
        return {};
      }
    },
    isAudioLevel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      logoGray: state => state.logoGray
    }),
    userId() {
      this.getNickName(this.userInfo.rtilCode);
      return this.userInfo.rtilCode;
    },
    managerRtil() {
      return this.userInfo.status ? this.userInfo.status.managerRtil : '';
    },
    spearkInfo() {
      this.getNickName(this.userInfo.status.speaker);
      return this.channel[this.userInfo.status.speaker || this.userInfo.status.output] || {};
    },
    questionInfo() {
      this.getNickName(this.userInfo.status.questionSpeaker);
      return this.channel[this.userInfo.status.questionSpeaker] || {};
    },
    shareList() {
      return this.channel[this.shareInfo.rtilCode] || {};
    },
    outputId() {
      return this.userInfo.status.output;
    },
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.MeInfo.id] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.MeInfo.id] == 90) {
        _str += 'rotate90';
      } else if (this.degreeHost[this.MeInfo.id] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.MeInfo.id] == 270) {
        _str += 'rotate270';
      }
      return _str;
    }
  },
  watch: {
    showRightAside(val) {
      this.setVideoWidth();
    }
  },
  data() {
    return {
      dealReporterShareHasUnsubscribe: false,
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      dealHasUnsubscribe: false,
      nameList: {},
      organizationList: {},
      waitText: 'In Questioner queue',
      waitNum: 0,
      setNameInfo: {
        show: false
      },
      questionerInfo: {},
      showFullScreen: false,
      showShareFullScreen: false,
      showQuestionerScreen: false,
      showSpeakerFullScreen: false,
      voiceList: {}
    };
  },
  created() {
    window.addEventListener('resize', this.setVideoWidth);
    this.$nextTick(() => {
      this.setVideoWidth();
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach((volume, index) => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.nameList, val.mark, val.value);
        }
        if (val.key == 'organization') {
          this.$set(this.organizationList, val.mark, val.value);
        }
      });
    });
    Bus.$on('setQuestioner', result => {
      if (result.rtilCode == this.userInfo.rtilCode) {
        this.getQuestionList();
      }
    });
    Bus.$on('setQuestionSpeaker', result => {
      this.State.questionerInfo = result;
      if (this.userInfo.role == 3) {
        this.getQuestionList();
      }
    });
    Bus.$on('cancelQuestionSpeaker', () => {
      this.State.questionerInfo = {};
      this.userInfo.status.questionSpeaker = '';
    });
    Bus.$on('questionerList', v => {
      this.questionList = v.questionerList || [];
      this.getPositionNum();
    });
    if (this.userInfo.role == 3) {
      this.getQuestionList();
    }
    // 处理初始化及其他 audio-only 时的视频订阅问题
    Bus.$on('setSubscribeTrack', payload => {
      this.spearkInfo.id = this.userInfo.status.speaker || this.userInfo.status.output;
      this.shareList.id = this.shareInfo.rtilCode;
      if (payload.id == this.userInfo.rtilCode) return;
      // mainWindow--spearkInfo(speark或者是outPut)
      if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id == payload.id) {
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            var _this$rtc;
            (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
          } else {
            var _this$rtc2;
            (_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2.unsubscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = true;
            this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              var _this$rtc3;
              (_this$rtc3 = this.rtc) === null || _this$rtc3 === void 0 ? void 0 : _this$rtc3.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = false;
              this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
            } else {
              this.spearkInfo.hasUnsubscribe = true;
              this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
            }
          } else {
            var _this$rtc4;
            (_this$rtc4 = this.rtc) === null || _this$rtc4 === void 0 ? void 0 : _this$rtc4.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
          }
        }
        this.$emit('dealHasUnsubscribe', {
          dealHasUnsubscribe: this.dealHasUnsubscribe,
          id: this.spearkInfo.id
        });
        return;
      }

      // 分享屏幕
      if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id == payload.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2 || this.State.checkShareScreen) {
            var _this$rtc5;
            (_this$rtc5 = this.rtc) === null || _this$rtc5 === void 0 ? void 0 : _this$rtc5.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.dealReporterShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          } else {
            var _this$rtc6;
            (_this$rtc6 = this.rtc) === null || _this$rtc6 === void 0 ? void 0 : _this$rtc6.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
            this.dealReporterShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              var _this$rtc7;
              (_this$rtc7 = this.rtc) === null || _this$rtc7 === void 0 ? void 0 : _this$rtc7.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.dealReporterShareHasUnsubscribe = this.shareList.hasUnsubscribe;
            } else {
              this.shareList.hasUnsubscribe = true;
              this.dealReporterShareHasUnsubscribe = this.shareList.hasUnsubscribe;
            }
          } else {
            var _this$rtc8;
            (_this$rtc8 = this.rtc) === null || _this$rtc8 === void 0 ? void 0 : _this$rtc8.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.dealReporterShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          }
        }
        this.$emit('dealReporterShareHasUnsubscribe', {
          dealReporterShareHasUnsubscribe: this.dealReporterShareHasUnsubscribe,
          id: this.shareList.id
        });
      }
    });
    // audioOnly选择器
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        if (val == 2) {
          if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.hasUnsubscribe) {
            var _this$rtc9;
            (_this$rtc9 = this.rtc) === null || _this$rtc9 === void 0 ? void 0 : _this$rtc9.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.$emit('dealHasUnsubscribe', {
              dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
            });
          }
          if (this.shareList.id != this.userInfo.rtilCode && this.shareList.hasUnsubscribe && this.shareList) {
            var _this$rtc10;
            // 分享屏幕
            (_this$rtc10 = this.rtc) === null || _this$rtc10 === void 0 ? void 0 : _this$rtc10.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealReporterShareHasUnsubscribe', {
              dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          }
          return;
        }
        // 1 allTime
        if (this.spearkInfo.id != this.userInfo.rtilCode && !this.spearkInfo.hasUnsubscribe) {
          if (!this.State.checkMainWindow) {
            var _this$rtc11;
            (_this$rtc11 = this.rtc) === null || _this$rtc11 === void 0 ? void 0 : _this$rtc11.unsubscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = true;
            this.$emit('dealHasUnsubscribe', {
              dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
            });
          }
        }
        if (this.shareList.id != this.userInfo.rtilCode && !this.shareList.hasUnsubscribe && this.shareList.id) {
          // 分享屏幕
          if (!this.State.checkShareScreen) {
            var _this$rtc12;
            (_this$rtc12 = this.rtc) === null || _this$rtc12 === void 0 ? void 0 : _this$rtc12.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
          }
          this.$emit('dealReporterShareHasUnsubscribe', {
            dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
          });
        }
      } else {
        // 0 自动
        if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.hasUnsubscribe) {
          if (!this.State.inAudioOnlyStatus) {
            var _this$rtc13;
            (_this$rtc13 = this.rtc) === null || _this$rtc13 === void 0 ? void 0 : _this$rtc13.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
          } else {
            if (this.State.checkMainWindow) {
              var _this$rtc14;
              (_this$rtc14 = this.rtc) === null || _this$rtc14 === void 0 ? void 0 : _this$rtc14.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = false;
            }
          }
          this.$emit('dealHasUnsubscribe', {
            dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
          });
        }
        if (this.shareList.id != this.userInfo.rtilCode && this.shareList.hasUnsubscribe && this.shareList) {
          // 分享屏幕
          if (!this.State.inAudioOnlyStatus) {
            var _this$rtc15;
            (_this$rtc15 = this.rtc) === null || _this$rtc15 === void 0 ? void 0 : _this$rtc15.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
          } else {
            if (this.State.checkShareScreen) {
              var _this$rtc16;
              (_this$rtc16 = this.rtc) === null || _this$rtc16 === void 0 ? void 0 : _this$rtc16.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
            }
          }
          this.$emit('dealReporterShareHasUnsubscribe', {
            dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
          });
        }
      }
    });
    // mainWindow 勾选
    Bus.$on('dealMainAudioOnly', val => {
      if (this.State.audioType) {
        // 2
        if (this.State.audioType == 2) {
          if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
            var _this$rtc17;
            (_this$rtc17 = this.rtc) === null || _this$rtc17 === void 0 ? void 0 : _this$rtc17.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.$emit('dealHasUnsubscribe', {
              dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
            });
          }
        } else {
          // 1
          if (val) {
            if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
              var _this$rtc18;
              (_this$rtc18 = this.rtc) === null || _this$rtc18 === void 0 ? void 0 : _this$rtc18.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = false;
              this.$emit('dealHasUnsubscribe', {
                dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
              });
            }
          } else {
            if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
              var _this$rtc19;
              (_this$rtc19 = this.rtc) === null || _this$rtc19 === void 0 ? void 0 : _this$rtc19.unsubscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = true;
              this.$emit('dealHasUnsubscribe', {
                dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
              });
            }
          }
        }
        // 0
      } else {
        // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
        if (!this.State.inAudioOnlyStatus) {
          if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
            var _this$rtc20;
            (_this$rtc20 = this.rtc) === null || _this$rtc20 === void 0 ? void 0 : _this$rtc20.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.$emit('dealHasUnsubscribe', {
              dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
            });
          }
        } else {
          if (val) {
            if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
              var _this$rtc21;
              (_this$rtc21 = this.rtc) === null || _this$rtc21 === void 0 ? void 0 : _this$rtc21.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = false;
              this.$emit('dealHasUnsubscribe', {
                dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
              });
            }
          } else {
            if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id) {
              var _this$rtc22;
              (_this$rtc22 = this.rtc) === null || _this$rtc22 === void 0 ? void 0 : _this$rtc22.unsubscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
              this.spearkInfo.hasUnsubscribe = true;
              this.$emit('dealHasUnsubscribe', {
                dealHasUnsubscribe: this.spearkInfo.hasUnsubscribe
              });
            }
          }
        }
      }
    });
    // shareScreen 勾选
    Bus.$on('dealShareAudioOnly', val => {
      if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            var _this$rtc23;
            (_this$rtc23 = this.rtc) === null || _this$rtc23 === void 0 ? void 0 : _this$rtc23.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealReporterShareHasUnsubscribe', {
              dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          } else {
            if (val) {
              var _this$rtc24;
              (_this$rtc24 = this.rtc) === null || _this$rtc24 === void 0 ? void 0 : _this$rtc24.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.$emit('dealReporterShareHasUnsubscribe', {
                dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            } else {
              var _this$rtc25;
              (_this$rtc25 = this.rtc) === null || _this$rtc25 === void 0 ? void 0 : _this$rtc25.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = true;
              this.$emit('dealReporterShareHasUnsubscribe', {
                dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            var _this$rtc26;
            (_this$rtc26 = this.rtc) === null || _this$rtc26 === void 0 ? void 0 : _this$rtc26.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealReporterShareHasUnsubscribe', {
              dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          } else {
            if (val) {
              var _this$rtc27;
              (_this$rtc27 = this.rtc) === null || _this$rtc27 === void 0 ? void 0 : _this$rtc27.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.$emit('dealReporterShareHasUnsubscribe', {
                dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            } else {
              var _this$rtc28;
              (_this$rtc28 = this.rtc) === null || _this$rtc28 === void 0 ? void 0 : _this$rtc28.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = true;
              this.$emit('dealReporterShareHasUnsubscribe', {
                dealReporterShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            }
          }
        }
      }
    });
    // audioOnly自动网络质量变化的情况下
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          if (this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id && this.spearkInfo.hasUnsubscribe) {
            var _this$rtc29;
            (_this$rtc29 = this.rtc) === null || _this$rtc29 === void 0 ? void 0 : _this$rtc29.subscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = false;
            this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
          }
          if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id && this.shareList.hasUnsubscribe) {
            var _this$rtc30;
            // 分享屏幕
            (_this$rtc30 = this.rtc) === null || _this$rtc30 === void 0 ? void 0 : _this$rtc30.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
          }
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          if (!this.State.checkMainWindow && this.spearkInfo.id != this.userInfo.rtilCode && this.spearkInfo.id && !this.spearkInfo.hasUnsubscribe) {
            var _this$rtc31;
            (_this$rtc31 = this.rtc) === null || _this$rtc31 === void 0 ? void 0 : _this$rtc31.unsubscribe(this.spearkInfo.id, 'video', 'unExecuteCallback');
            this.spearkInfo.hasUnsubscribe = true;
            this.dealHasUnsubscribe = this.spearkInfo.hasUnsubscribe;
          }
          if (!this.State.checkShareScreen && this.shareList.id != this.userInfo.rtilCode && this.shareList.id && !this.shareList.hasUnsubscribe) {
            var _this$rtc32;
            (_this$rtc32 = this.rtc) === null || _this$rtc32 === void 0 ? void 0 : _this$rtc32.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
          }
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (key == 'nickName' && this.nameList[rtilCode]) {
        this.$set(this.nameList, rtilCode, value);
      }
    });
  },
  methods: {
    hasChangeMic() {
      var _this$$refs$localVide, _this$$refs$localVide2;
      (_this$$refs$localVide = this.$refs.localVideo) === null || _this$$refs$localVide === void 0 ? void 0 : (_this$$refs$localVide2 = _this$$refs$localVide.reAddAudioContext) === null || _this$$refs$localVide2 === void 0 ? void 0 : _this$$refs$localVide2.call(_this$$refs$localVide);
    },
    attendCallback(obj) {
      const {
        type,
        id,
        val
      } = obj;
      if (type == 'reName') {
        this.setNameInfo.show = true;
        this.setNameInfo.hideBtn = true;
        this.setNameInfo.userInfo = {
          ...this.userInfo,
          realPartyCode: this.$route.query.id
        };
      } else if (type == 'muteAudio' || type == 'muteVideo') {
        this.$emit('callback', obj);
      } else if (type === 'fullScreen') {
        if (this.spearkInfo && this.spearkInfo.id == id) {
          this.showSpeakerFullScreen = val;
        } else if (this.State.questionerInfo.rtilCode == id) {
          this.showQuestionerScreen = val;
        } else if (this.shareList && this.shareList.id == id) {
          this.showShareFullScreen = val;
        } else {
          this.showFullScreen = val;
        }
        this.$emit('callback', {
          type: 'fullScreen',
          val
        });
      } else if (type === 'audioContext') {
        this.$emit('callback', {
          type: 'audioContext',
          val
        });
      }
    },
    setNickName(obj) {
      this.userInfo.behavior.nickName = obj.nickName;
      this.userInfo.behavior.organization = obj.organization;
    },
    setVideoWidth() {
      if (this.showSpeakerFullScreen) return;
      const heightRem = 9 / 16;
      const widthRem = 16 / 9;
      if (document.getElementsByClassName('speaker')[0]) {
        const height = document.getElementsByClassName('speaker')[0].clientHeight;
        document.getElementsByClassName('speaker')[0].style.maxWidth = height * widthRem + 'px';
        const width = document.getElementsByClassName('speaker')[0].clientWidth;
        if (width * heightRem > height) {
          // 计算出当前宽度下，video的高度是否超过屏幕的宽度
          // 超过时,则使用height来计算width
          document.getElementsByClassName('is-speaker')[0].style.width = height * widthRem + 'px';
          document.getElementsByClassName('is-speaker')[0].style.height = height + 'px';
        } else {
          document.getElementsByClassName('is-speaker')[0].style.width = width + 'px';
          document.getElementsByClassName('is-speaker')[0].style.height = width * heightRem + 'px';
        }
        if (this.showRightAside) {
          const right = document.getElementsByClassName('reporters')[0].clientWidth - width;
          document.getElementsByClassName('reporter')[0].style.right = right / 2 + 10 + 'px';
          document.getElementsByClassName('MuteBox')[0].style.marginRight = right / 2 + 'px';
        }
      }
    },
    getNickName(id) {
      if (!this.$route.query.id) return;
      if (id) {
        this.axios.post('/partyline-backend/behavior/noLogin/getList', {
          annotation: this.$route.query.id,
          keys: ['nickName', 'organization'],
          marks: [id]
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            const {
              nickName,
              organization
            } = res.data.result[id] || {};
            this.$set(this.organizationList, id, organization);
            this.$set(this.nameList, id, nickName);
          }
        });
      }
    },
    getQuestionList() {
      this.axios.get(`/partyline-backend/conference/noLogin/questionerList/${this.$route.query.id}`).then(res => {
        if (res.data.errorCode == '0x0') {
          this.questionList = res.data.result || [];
          this.getPositionNum();
        }
      });
    },
    getPositionNum() {
      this.questionList.forEach((v, k) => {
        if (v.rtilCode == this.userInfo.rtilCode) {
          this.waitNum = v.position;
        }
      });
      if (this.waitNum <= 3) {
        this.waitText = `${this.waitNum} participants ahead of you`;
      } else {
        this.waitText = 'In Questioner queue';
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVideoWidth);
  }
};